import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Header, Dropdown, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import DetailTable from './Table';
import './styles.scss';

class SearchCombos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'selectChassis': '',
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.SearchCombosVehicles,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearCombosByChassis();
    this.props.clearCombosBySearchParam();
  }

  handleSearchVehicles = (e, {searchQuery}) => {
    if (searchQuery.length >= 4) {
      this.props.getCombosBySearchParam(searchQuery);
    }
    this.setState({
      'selectChassis': '',
    });
  };

  handleSelectItem = (e, {value}) => {
    this.setState({
      'selectChassis': value,
    });
  };

  handleSearch = () => {
    const {selectChassis} = this.state;
    this.props.getComboByChasis(selectChassis);
  };

  render() {
    const {combos, loading, vehicles, loadingVehicles} = this.props;
    const {selectChassis} = this.state;

    return (
      <div className='container-vehicle-combos'>
        <Card raised fluid>
          <div className='container-vehicle-combos-title'>
            <Header as='h2'>Búsqueda de Combos</Header>
            <div className='container-vehicle-combos-search'>
              <div className='container-vehicle-combos-search-input'>
                <Dropdown
                  placeholder='Chasis'
                  fluid
                  noResultsMessage='No se encontro resultados'
                  search
                  selection
                  loading={loadingVehicles}
                  disabled={loadingVehicles}
                  options={vehicles}
                  value={selectChassis}
                  onChange={this.handleSelectItem}
                  onSearchChange={this.handleSearchVehicles}
                />
                <Button
                  disabled={selectChassis === ''}
                  onClick={this.handleSearch}
                  type='submit'
                  color='green'
                >
                  BUSCAR
                </Button>
              </div>
              <div>
                <h3>{selectChassis && `Chasis ${selectChassis}`}</h3>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid>
          <DetailTable combos={combos} loading={loading} />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'combos': state.vehicleCombosByChasis.combos,
    'loading': state.vehicleCombosByChasis.loading,
    'vehicles': state.vehicleCombosList.vehicles,
    'loadingVehicles': state.vehicleCombosList.loading,
  };
};

const {
  navigateTo,
  getComboByChasis,
  getCombosBySearchParam,
  clearCombosByChassis,
  clearCombosBySearchParam,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  getComboByChasis,
  getCombosBySearchParam,
  clearCombosByChassis,
  clearCombosBySearchParam,
})(SearchCombos);
